import { Request } from "./HttpService";

export const searchService = {
  search(parm) {
    return Request(`vitae/search/${parm}`, "GET");
  }
};
